import { PdfHeader } from "../../../../components";
import UiWarningRating from "../../../../components/uiWarning";
import { formatPhoneNumber } from "../../../../utils/appUtils";

const ApprovedlawyerReport = ({ lawyerProfileData, activeTab, lawyerProfilePic }) => {
    return <div className="approval-Report">
        <div className="report-container">
            <PdfHeader pdfName={activeTab === "REJECTED"?"Rejected Advocate Report":"Approved Advocate Report"} />
            <div style={{ padding: "10px" }}>
                <div className="lawyer-information">
                    <div style={{ display: "flex", width: "100%", justifyContent: "space-between", gap: "0px 10px" }}>
                        <div className="flexible-start" style={{ width: "50%" }} >
                            <img src={lawyerProfilePic} alt="" className="profile-image" />
                            <div>
                                <h4 className="lawerInfo-detail" style={{ fontWeight: 500 }}>{lawyerProfileData?.salutation} {lawyerProfileData?.firstName || "Nil"} {lawyerProfileData?.middleName || "Nil"} {lawyerProfileData?.lastName || "Nil"}</h4>
                                {activeTab === "APPROVED" && <div style={{ padding: "5px 10px" }}>
                                    <UiWarningRating count={lawyerProfileData?.warningCountAfterActive} />
                                </div>}
                            </div>
                        </div>
                        <div style={{ width: "50%" }}>
                            <div className="flexible-end">
                                <div>
                                    <small className="lawyerReport-heading">Advocate ID</small>
                                    <p className="lawyerReport-info">{lawyerProfileData?.lawyerNo || "Nil"}</p>
                                </div>
                                <div>
                                    <small className="lawyerReport-heading">mobileNumber</small>
                                    <p className="lawyerReport-info">{lawyerProfileData?.mobileNumber ? formatPhoneNumber(lawyerProfileData?.mobileNumber) : "Nil"}</p>
                                </div>
                                <div>
                                    <small className="lawyerReport-heading">E-mail Address</small>
                                    <p className="lawyerReport-info">{lawyerProfileData?.email || "Nil"}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ padding: "10px" }}>
                <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
                    <h3 className="lawerInfo-detail" >Consultion Details</h3>
                </div>
                <div className="flexible-start">
                    <div>
                        <small className="information-header">Total Cons.</small>
                        <h3 className="lawerInfo-detail">{lawyerProfileData?.totalConsultationCount ? lawyerProfileData?.totalConsultationCount : 0}</h3>
                    </div>
                    <div>
                        <small className="information-header">Cancel Cons.</small>
                        <h3 className="lawerInfo-detail">{lawyerProfileData?.cancelConsultationCount ? lawyerProfileData?.cancelConsultationCount : 0}</h3>
                    </div>
                </div>
            </div>
            <div style={{ padding: "10px" }}>
                <div style={{ borderBottom: "1px solid #00000054", padding: "10px" }}>
                    <h3 className="lawerInfo-detail">Professional Details</h3>
                </div>
                <div className="flexible">
                    <div>
                        <small className="information-header">Bar Council No</small>
                        <h4 className="lawerInfo-detail">{lawyerProfileData?.barCouncilId || "Nil"}</h4>
                    </div>
                    <div>
                        <small className="information-header">Specialization</small>
                        <h4 className="lawerInfo-detail"> {lawyerProfileData?.specialization?.length > 2 ? (
                            <>
                                {lawyerProfileData.specialization?.slice(0, 2)?.join(", ") || "Nil"}
                                <br />
                                {lawyerProfileData.specialization?.slice(2)?.join(", ") || "Nil"}
                            </>
                        ) : (
                            lawyerProfileData?.specialization?.join(", ") || "Nil"
                        )}</h4>
                    </div>
                    <div>
                        <small className="information-header">Experience</small>
                        <h4 className="lawerInfo-detail">{lawyerProfileData?.experience ? `${lawyerProfileData?.experience} Years` : "Nil"}</h4>
                    </div>
                    <div>
                        <small className="information-header">Qualification</small>
                        <h4 className="lawerInfo-detail">{lawyerProfileData?.qualification || "Nil"}</h4>
                    </div>

                </div>
            </div>
            <div style={{ padding: "10px" }}>
                <div style={{ borderBottom: "1px solid #00000054", padding: "10px" }}>
                    <h3 className="lawerInfo-detail">Personal Details</h3>
                </div>
                <div className="flexible">
                     <div>
                        <small className="information-header">Address 1</small>
                        <h4 className="lawerInfo-detail">{lawyerProfileData?.address1 || "Nil"}</h4>
                    </div>
                    <div>
                        <small className="information-header">Address 2</small>
                        <h4 className="lawerInfo-detail">{lawyerProfileData?.address2 || "Nil"}</h4>
                    </div>
                    <div>
                        <small className="information-header">State</small>
                        <h4 className="lawerInfo-detail">{lawyerProfileData?.state || "Nil"}</h4>
                    </div>
                    <div>
                        <small className="information-header">District</small>
                        <h4 className="lawerInfo-detail">{lawyerProfileData?.district || "Nil"}</h4>
                    </div>
                    <div>
                        <small className="information-header">City</small>
                        <h4 className="lawerInfo-detail">{lawyerProfileData?.city || "Nil"}</h4>
                    </div>
                    <div>
                        <small className="information-header">Pincode</small>
                        <h4 className="lawerInfo-detail">{lawyerProfileData?.pincode || "Nil"}</h4>
                    </div>
                </div>
            </div>
            <div style={{ padding: "10px" }}>
                <div style={{ borderBottom: "1px solid #00000054", padding: "10px" }}>
                    <h3 className="lawerInfo-detail">Bio/About You</h3>
                </div>
                <div style={{ padding: "0px 10px" }}>
                    <p >{lawyerProfileData?.aboutAs || "Nil"}</p>
                </div>
            </div>
            {
                activeTab === "REJECTED" && <div style={{ padding: "10px" }}>
                    <div style={{ borderBottom: "1px solid #00000054", padding: "10px" }}>
                        <h3 className="lawerInfo-detail">Reason For Rejected</h3>
                    </div>
                    <div style={{ padding: "0px 10px" }}>
                        <p >{lawyerProfileData?.rejectedReason || "Nil"}</p>
                    </div>
                </div>
            }
        </div>
    </div>
};
export default ApprovedlawyerReport